// "Add a note" on a deal card (REQ-2026-10-08-13; migration 261). Mike, 8 Oct 2026: "deal cards need to have the option to
// add a note like we have in the company register", and "The note also asses what should happen with the deal in respect
// to its stage, keenness etc"; by pop-up, "Button in the card's foot (Recommended)" and "Change it, say why, Undo
// (Recommended)".
//
// The company record's box (records/CompanyNotes.tsx NotesBox), opened from the card's foot: a note typed or added as a
// file goes up against this deal, so it is filed under this deal (not the company's top line) and is on the company's
// record too. Listed under the box: every note on the deal the reader may read, newest first, with who added it and when,
// fetched only when the box is opened. What the note means for the deal is the deal reader's, as for any message
// (deals/read, U204, U294): it moves the stage, the keenness or the figure, the card says why, and one press undoes it.
import { viewFetch as fetch } from '../view-as.js';
import { Unauthenticated } from '../api.js';
import { NotesBox, type CompanyNote } from '../records/CompanyNotes.js';
import { useLoad } from '../records/shared.js';

export async function readDealNotes(store: string, dealId: string): Promise<{ notes: CompanyNote[]; total: number }> {
  const r = await fetch(`/api/deals/${encodeURIComponent(dealId)}/notes?${new URLSearchParams({ store }).toString()}`, { credentials: 'same-origin' });
  if (r.status === 401) throw new Unauthenticated();
  if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
  const j = (await r.json()) as { notes: CompanyNote[]; total: number };
  return { notes: j.notes, total: j.total };
}

/** "Add a note to Bet365's Premier Padel deal", or "... to this deal with Bet365" when the deal names no product. */
export const dealNoteLabel = (account: string | null, product: string | null): string =>
  // BUGS.md D97: an account put away is not named.
  account === null ? (product ? `Add a note to the ${product} deal` : 'Add a note to this deal')
    : product ? `Add a note to ${account}’s ${product} deal` : `Add a note to this deal with ${account}`;

export function DealNotes({ storeId, dealId, account, product, open, onAdded }: {
  storeId: string; dealId: string; account: string | null; product: string | null; open: (path: string) => void;
  /** After a note is added: the card reads its deal again, so a change the reader has made since shows. */
  onAdded?: () => void;
}) {
  const [load, reload] = useLoad(() => readDealNotes(storeId, dealId), [storeId, dealId], { keep: true });
  return (
    <div className="lv-notes" role="region" aria-label="Notes on this deal">
      <NotesBox storeId={storeId} on={{ deal: dealId }} idBase={`lv-note-${dealId}`} label={dealNoteLabel(account, product)}
        fileName={`Note on ${[account, product].filter(Boolean).join(' ') || 'the deal'}.txt`} load={load} reload={() => { reload(); onAdded?.(); }} open={open}
        after={<p className="read">Cobrain reads each note for this deal: a change it makes to the stage, the keenness or the figure shows on this card with why, and one press undoes it.</p>} />
    </div>
  );
}
